import React, { useState } from 'react';
import { DataTable, columnTypes } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import ReportNote from '../../../components/ReportNote';
import ReportCard from '../../../components/ReportCard';
import StyledNotesContainer from './StyledNotesContainer';

export default ({ playerId }) => {
    const { t: translate } = useTranslation();
    const [hasMatchupNote, setHasMatchupNote] = useState(true);
    const hasMatchupNoteCallback = (data) => setHasMatchupNote(data);

    return (
        <ReportCard title={translate('sections.opponent.player.matchup-positioning-note')}>
            <StyledNotesContainer>
                {playerId && (
                    <DataTable
                        striped={false}
                        columns={[{
                            id: 'note',
                            type: columnTypes.TEXT,
                            transform: () => (
                                <ReportNote
                                    type="oart"
                                    section={3}
                                    playerId={playerId}
                                    hasDataCallback={hasMatchupNoteCallback}
                                />
                            ),
                        }]}
                        rows={[{}]}
                    />
                )}
                { !hasMatchupNote && <>{translate('sections.opponent.player.none-found')}</>}
            </StyledNotesContainer>
        </ReportCard>
    );
};
